import { render, staticRenderFns } from "./TestimonialsSales.vue?vue&type=template&id=67c4f472&"
import script from "./TestimonialsSales.vue?vue&type=script&lang=ts&"
export * from "./TestimonialsSales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports